import moment from 'moment'
import * as React from 'react'
import DatePicker from 'react-datepicker'
import { FullWidthInput } from './PromoForm.styles'

interface MultiDateInputProps {
    onDeleteDate: () => void;
    onEnterDate: (newDate: Date) => void;
    values: Date[];
}

export default function MultiDateInput({
    onDeleteDate,
    onEnterDate,
    values,
}: MultiDateInputProps) {
    const DatePickerCustomInput = React.forwardRef(
        (props: { onClick?: () => void; onKeyDown?: () => void }, ref) => (
            <FullWidthInput
                key="promo-exception-dates"
                id="promo-exception-dates"
                name="promo-exception-dates"
                ref={ref}
                type="text"
                onClick={props.onClick}
                onKeyDown={props.onKeyDown}
                value={values.map(date => moment(date).format('DD/MM/YYYY')).join(', ')}
                autocomplete={false}
            />
        ),
    )

    const onKeyDown = (e: React.KeyboardEvent) => {
        if (e.code === 'Backspace') {
            onDeleteDate()
        }
    }

    return (
        <>
            <DatePicker
                onChange={onEnterDate}
                onKeyDown={onKeyDown}
                customInput={<DatePickerCustomInput />}
            />
        </>
    )
}
